export default __webpack_public_path__ + "static/media/Lab_Partner_5_PCR_Product.712dac07.svg";